import * as Sentry from "@sentry/browser";

export const handleError = (error: Error): void => {
    Sentry.captureException(error);
    return console.error(error);
};
